import React from 'react';

const HeroSection = () => {
  return (
    <section className="relative pt-16 pb-20 px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto relative">
        <div className="text-center max-w-4xl mx-auto">
          {/* Title */}
          <h1 className="text-5xl lg:text-7xl font-bold tracking-tight mb-6">
            <span className="text-white">Creating Worlds</span>
            <br />
            <span className="bg-gradient-to-r from-[#ffab3e] to-amber-100 bg-clip-text text-transparent">
              Frame by Frame
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl text-gray-300 max-w-2xl mx-auto mb-10 leading-relaxed">
            VFX Artist specializing in digital matte painting and concept art for 
            feature films and high-end television productions.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/portfolio"
              className="px-8 py-4 bg-[#ffab3e] hover:bg-[#e69a36] text-black font-semibold rounded-none transition-all shadow-lg shadow-black/40 hover:shadow-xl"
            >
              View Portfolio
            </a>
            <a
              href="/contact"
              className="px-8 py-4 bg-white/5 hover:bg-white/10 text-gray-100 font-semibold rounded-none border border-white/20 transition-all"
            >
              Get In Touch
            </a>
            <a
              href="https://www.neevii.com/ink"
              className="px-8 py-4 bg-[#8b5cf6]/[0.15] hover:bg-[#8b5cf6]/25 text-white font-semibold rounded-none border border-[#ffab3e] transition-all focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#8b5cf6]"
            >
              Neevii Ink &amp; VFX Tools
            </a>
          </div>

          {/* Home page video */}
          <div className="mt-12 bg-black">
            <video
              className="w-full block bg-black outline-none"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              src="/assets/home/Concepts_v003.mp4"
            >
              Your browser does not support the video tag.
            </video>
          </div>

          {/* Credits */}
          <div className="mt-16 pt-8 border-t border-white/10">
            <p className="text-sm text-gray-500 mb-4">Featured work on</p>
            <div className="flex flex-wrap justify-center gap-8 text-gray-400">
              <span className="text-lg font-medium">Film</span>
              <span className="text-lg font-medium">Television</span>
              <span className="text-lg font-medium">Streaming</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
